<script>
  function HandleResize() {

  }
</script>
<div class="app-header">
  <img class="logo" [src]="logo" />
  <div #pageTitleContainer class="page-title-container"></div>
</div>
<router-outlet></router-outlet>

<app-project-config-dialog></app-project-config-dialog>
<app-attribute-conditions-dialog></app-attribute-conditions-dialog>
<app-attribute-option-editor-dialog></app-attribute-option-editor-dialog>
<app-project-load-dialog></app-project-load-dialog>
<app-project-save-dialog></app-project-save-dialog>
<app-route-config-dialog></app-route-config-dialog>
<app-modal-messager></app-modal-messager>
